<template>
  <div>
    <el-descriptions
      title="用户档案-详情信息"
      direction="horizontal"
      :column="2"
      border
    >
      <el-descriptions-item label="账号">{{UserProfileDetails.id}}</el-descriptions-item>
      <el-descriptions-item label="用户名">{{UserProfileDetails.nickName}}</el-descriptions-item>
      <el-descriptions-item label="手机号">{{UserProfileDetails.phoneNumber}}</el-descriptions-item>
      <el-descriptions-item label="剩余积分">{{UserProfileDetails.residuePoint}}</el-descriptions-item>
      <el-descriptions-item label="分享量">{{UserProfileDetails.shareCount}}</el-descriptions-item>
      <el-descriptions-item label="分享点击量">{{UserProfileDetails.shareClickCount}}</el-descriptions-item>
      <el-descriptions-item label="勋章个数">{{UserProfileDetails.totalMedal}}</el-descriptions-item>
      <el-descriptions-item label="勋章">{{UserProfileDetails.totalMedalName}}</el-descriptions-item>
      <el-descriptions-item label="来源">
        <span v-if="UserProfileDetails.userSource==1">自主注册</span>
        <span v-if="UserProfileDetails.userSource==2">他人推广</span>
        <span v-if="UserProfileDetails.userSource==3">系统推广</span>
        <span v-if="UserProfileDetails.userSource==4">其他</span>
      </el-descriptions-item>
      <el-descriptions-item label="拉新推广人姓名">{{UserProfileDetails.inviteUserName}}</el-descriptions-item>
      <el-descriptions-item label="拉新推广人手机">{{UserProfileDetails.inviteUserPhoneNumber}}</el-descriptions-item>
      <el-descriptions-item label="总拉新人数">{{UserProfileDetails.inviteUserCount}}</el-descriptions-item>
      <el-descriptions-item label="总收入（元）">{{UserProfileDetails.totalIncomeAmount}}</el-descriptions-item>
      <el-descriptions-item label="总提现（元）">{{UserProfileDetails.totalWithdrawalAmount}}</el-descriptions-item>
      <el-descriptions-item label="总未提现（元）">{{UserProfileDetails.totalUnWithdrawalAmount}}</el-descriptions-item>
      <el-descriptions-item label="用户首次购买提成（元）">{{UserProfileDetails.firstBuyCommissionAmount}}</el-descriptions-item>
      <el-descriptions-item label="拉新终身提成（元）">{{UserProfileDetails.lifetimeCommissionAmount}}</el-descriptions-item>
      <el-descriptions-item label="用户再次通过分享链接购买提成（元）">{{UserProfileDetails.againBuyCommissionAmount}}</el-descriptions-item>
      <el-descriptions-item label="总消费（元）">{{UserProfileDetails.totalAmount}}</el-descriptions-item>
      <el-descriptions-item label="历史总积分">{{UserProfileDetails.totalPoint}}</el-descriptions-item>
      <el-descriptions-item label="订单量">{{UserProfileDetails.totalOrderCount}}</el-descriptions-item>
      <el-descriptions-item label="看视频个数">{{UserProfileDetails.totalVideoCount}}</el-descriptions-item>
      <el-descriptions-item label="看视频时长（分钟）">{{UserProfileDetails.totalVideoDuration}}</el-descriptions-item>
    </el-descriptions>

    
  </div>
</template>

<script>
import util from "../../../../util/date";
import {
	getUserProfileDetails
} from "../../../api/api";

export default {
  components: {},
  data() {
    return {
      id:'',
      listLoading:false,
      UserProfileDetails:{}
    };
  },
  methods: {
    //获取用户统计列表
    getList() {
      this.listLoading = true;
      var params = {
        id:this.id
      };
      getUserProfileDetails(params).then((res) => {
        this.UserProfileDetails= res.data.response;
        this.listLoading = false;
      });
    }
  },
  mounted() {
    this.utils = util;
    this.id = this.$route.query.id
    this.getList();
  
  },
};
</script>
<style lang="stylus" scoped>

</style>
